import { colors } from '@lmc/common/constants'
import React from 'react'
import MARChartCell from '../MARChartCell'
import MARChartMedicationCell from '../MARChartMedicationCell'
import { getCellClass } from './cellClassFunctions'

/**
@description The render function for the hour column. Passed to the Table component

@param {string} value. The cell value. E.g. 08:00

@param {object} row. The row object. Contains all entries for
the row. Important prop is key, which determines what kind of
row it is, e.g. 'medication', 'gutter'.

@returns {object} The hour column object.
*/

export const renderHourColumn = (value, row) => {
  const { isMedLinkActive, medication, type } = row
  const obj = {
    children: value
  }

  if (type === 'medication') {
    const children = isMedLinkActive ? (
      <MARChartMedicationCell name={value} medication={medication} />
    ) : (
      value
    )

    return {
      children,
      props: {
        ...obj.props,
        colSpan: 13,
        style: styles.medicationRow
      }
    }
  }
  if (type === 'gutter') {
    return {
      ...obj,
      props: {
        ...obj.props,
        className: 'gutter',
        colSpan: 100,
        style: styles.gutterRow
      }
    }
  }

  return {
    ...obj,
    props: {
      ...obj.props,
      style: styles.basicColumn
    }
  }
}

/**
@description The render function for the dose column. Passed to the Table component

@param {string} value. The cell value. E.g. TWO

@param {object} row. The row object. Contains all entries for
the row. Important prop is key, which determines what kind of
row it is, e.g. 'medication', 'gutter'.

@returns {object} The dose column object.
*/

export const renderDoseColumn = (value, row) => {
  const { type } = row
  const obj = {
    children: value,
    props: {
      style: styles.basicColumn
    }
  }

  if (type === 'medication' || type === 'gutter') {
    return {
      ...obj,
      props: {
        ...obj.props,
        colSpan: 0
      }
    }
  }

  return obj
}

/**
@description The render function for the default columns in the table. Passed to the Table component

@param {object} value. All data for the cell. E.g. { loggedBy: '1', reasonCode: 'C', ... }

@param {object} row. The row object. Contains all entries for
the row. Important prop is key, which determines what kind of
row it is, e.g. 'medication', 'gutter'.

@returns {object} The default column object.
*/

export const renderDefaultColumn = (value, row) => {
  const { type } = row

  const cellClass = getCellClass({ value, row })

  const obj = {
    children: <MARChartCell value={value} />,
    props: {
      className: cellClass,
      style: {
        ...styles.basicColumn,
        ...styles.defaultColumn
      }
    }
  }

  if (type === 'medication' || type === 'gutter') {
    return {
      ...obj,
      props: {
        ...obj.props,
        colSpan: 0
      }
    }
  }

  return obj
}

const styles = {
  basicColumn: {
    borderTop: `1px solid ${colors.lightgrey}`,
    textAlign: 'center'
  },
  defaultColumn: {},
  gutterRow: {
    backgroundColor: `${colors.background} !important`,
    pointerEvents: 'none'
  },
  medicationRow: {
    border: 'none',
    fontSize: 16,
    fontWeight: 700,
    paddingLeft: 16
  }
}
